@if (isLoading) {
	<div class="loading-overlay">
		<img class="spinner" src="./assets/spinner2.gif" style="opacity: 0; transition: opacity 0.2s" />
	</div>
}
<div class="service-header-wrapper">
	<h2 class="mat-heading" style="flex: 2">{{ 'masterdata.cutting.rules' | translate }}</h2>
	<div class="service-header-buttons">
		<div class="acies-density-high acies-list-search-field">
			<mat-form-field>
				<input matInput [placeholder]="'insights.administration.users.search' | translate" [(ngModel)]="rulesFilter" />
				<button mat-icon-button matPrefix>
					<mat-icon svgIcon="acies_search"></mat-icon>
				</button>
			</mat-form-field>
		</div>
		<header-sub-menu [favoriteItems]="favoriteItems" [menuItems]="menuItems"></header-sub-menu>
	</div>
</div>

<app-generictable
	[hidden]="(count$ | async) <= 0"
	[tableSource]="tableSource"
	[hasSelectColumn]="false"
	[tableColumns]="registerTableColumns"
	[pageSizes]="pageSizes"
	[initialPageSize]="initialPageSize"
	[showFirstLastButtons]="false"
	[filterWord]="rulesFilter"
	[rowActions]="regRowActions"
	(selectedList)="handleSelected($event)"
	(menuEmitter)="handleRowMenuAction($event)"
	(paginatorEmitter)="handleReloadData($event)"
	[totalRowCount]="count$ | async"></app-generictable>
